import { replaceDomain } from "../help/url";
import { cr } from "fire-wind-water";

class Match {
  ws: string[] = [
    "f.smarket.net.cn",
    "file.smarket.net.cn",
    "saas-project.sinobase.cn",
    "activity.sangfor.com.cn",
  ];

  replace(d) {
    if (d.formalUrl) {
      d.formalUrl = this.replaceDomain(d.formalUrl);
      cr.each(d.html, (m, i) => {
        if (m.formalUrl) {
          d.html[i].formalUrl = this.replaceDomain(m.formalUrl);
        }
      });
    }
  }

  replaceDomain(s) {
    let c = s;
    const r = /\/\/([^/]+)\//;
    let a = s.match(r);
    a = a ? a[1] : null;
    let b: any = window.location.href.match(r);
    b = b ? b[1] : null;
    if (a && this.ws.indexOf(a) > -1 && b && this.ws.indexOf(b) > -1) {
      c = replaceDomain(s);
    }
    return c;
  }
}

export const $match = new Match();
